<template>
    <div class="hard-competences-wrapper">
        <HardCompetencesEmpty v-if="!getHardCompetences.length" />
        <div class="content" v-else>
            <div class="main-content">
                <div class="titles">
                    <div
                        class="title"
                        v-for="(item, index) in getCompetenceKnowledge"
                        :key="index"
                    >{{item}}</div>
                </div>
                <Slider
                    class="slider"
                    :itemWidth="129"
                    :itemsCount="getHardCompetences.length"
                >
                    <HardCompetences
                        :competences="getHardCompetences"
                    />
                </Slider>
            </div>
            <div class="legend">
                <div class="description">
                    Проходите обучение и отмечайте прокаченные навыки
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HardCompetences from './HardCompetences';
import HardCompetencesEmpty from './HardCompetencesEmpty';

const trackGetters = [
    'getHardCompetences',
    'getCompetenceKnowledge',
];

import Slider from '../Slider';

export default {
    name: 'HardCompetencesWrapper',
    components: {
        Slider,
        HardCompetences,
        HardCompetencesEmpty,
    },
    data: ()=>({}),
    computed: {
        ...mapGetters('accountTrack', trackGetters),
    },
};
</script>

<style lang="scss" scoped>
    .hard-competences-wrapper{
        padding: 24px;
        .main-content {
            display: flex;
            flex-direction: row;
            .titles{
                width: 100px;
                margin-top: 90px;
                font-style: normal;
                font-weight: 600;
                font-size: 14px;
                line-height: 20px;
                color: #98A0A9;
                .title{
                    height: 48px;
                }
            }
            .slider{
                flex: 1;
            }
        }
        .legend{
            display: flex;
            flex-direction: row;
            margin-top: 16px;
            .description{
                flex: 1;
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                line-height: 24px;
                color: #2A2626;
            }
        }
    }
</style>